<template>
  <div id="prod-editor">
    <mt-header fixed title="产品信息">
      <router-link to="/index/prod" slot="left">
        <mt-button icon="back">返回</mt-button>
      </router-link>
    </mt-header>
    <div v-if="prodInfo.imageId" style="text-align:center;padding:1rem;">
      <img
        v-gallery
        :src="this.GLOBAL.serverUrl + '/attach/' + prodInfo.imageId + '/download'"
        style="max-height:12rem;"
      />
    </div>
    <mt-field label="产品名称" readonly v-model="prodInfo.name"></mt-field>
    <mt-cell
      title="溯源码数量"
      is-link
      :to="'prod/afcode/record?id=' + prodId"
      readonly
      v-model="prodInfo.afCodeNum"
    ></mt-cell>
    <div class="page-btn">
      <mt-button type="primary" @click.native="downCode">生成溯源码</mt-button>
      <mt-button type="primary" @click.native="editProd">修改产品信息</mt-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import "mint-ui/lib/style.css";
import { Toast, Cell, Button, Field, Header } from "mint-ui";
import gallery from "img-vuer";
Vue.use(gallery, {
  swipeThreshold: 150, // default 100
  isIndexShow: false, // show image index, default true
  useCloseButton: true, // trigger gallery close with close button, default true
  preload: true // preload images in the same group, default true
});

export default {
  props: ["prodId"],
  components: {Toast, Cell, Button, Field, Header},
  data: function() {
    return {
      prodInfo: {
        id: null,
        name: null,
        imageId: null,
        pkgNum: 1,
        afCodeNum: 0
      }
    };
  },
  methods: {
    downCode: function() {
      this.$router.push("/prod/afcode/down?id=" + this.prodInfo.id + "&pkgNum=" + this.prodInfo.pkgNum);
    },
    editProd: function() {
      this.$router.push("/prod/edit?id=" + this.prodInfo.id);
    }
  },
  mounted: function() {
    if (this.prodId) {
      this.$http
        .get(
          this.GLOBAL.serverUrl + "/ent/prod/" + this.prodId + "/afcode/summary"
        )
        .then(function(resp) {
          if (resp.body.code == 200) this.prodInfo = resp.body.data;
          else if (resp.body.code == 500) Toast("获取数据失败，请稍后再试！");
        });
    }
  }
};
</script>
<style scoped>
#prod-editor {
  padding-top: 40px;
}
.page-btn {
  margin-top: 2rem;
  padding: 0 1rem;
  text-align: center;
}
.page-btn button {
  margin: 0 0.5rem;
}
</style>